import { derived } from "svelte/store";
import { getMediaQuery } from "app/utils/mediaQuery";
import { isTeamMember } from "./permissions";

const isDesktop = getMediaQuery("desktop");

export const showAdminPanel = derived(
  [isDesktop, isTeamMember],
  ([$isDesktop, $isTeamMember]) => $isDesktop && $isTeamMember
);
